import React from 'react';
import { GenericFormPage, GenericDetailPage } from '../../../components/generic';
import { useAccDocumentType, AccDocumentType } from './useData';
import {
  moduleConfig,
  getDetailSections,
  getInitialFormData,
  mapItemToFormData,
  getStatusBadges,
} from './config';

export { default as List } from './List';

export const Form: React.FC = () => (
  <GenericFormPage<AccDocumentType>
    useData={useAccDocumentType}
    config={{ ...moduleConfig, getInitialFormData, mapItemToFormData }}
  />
);

export const Detail: React.FC = () => (
  <GenericDetailPage<AccDocumentType>
    useData={useAccDocumentType}
    config={{ ...moduleConfig, getDetailSections, getStatusBadges }}
  />
);
